import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import './index.scss';
import {
  ToastContainer,
  ToastOptions,
  toast,
  Slide,
  CloseButtonProps,
} from 'react-toastify';
import successIcon from '@/assets/vod/icon/states_24px_congratulate.png';
import warnIcon from '@/assets/vod/icon/states_24px_horn.png';
import errorIcon from '@/assets/vod/icon/states_24px_warning.png';

const commonConfig: ToastOptions = {
  position: 'top-center',
  autoClose: 2000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
  transition: Slide,
  theme: 'light',
  closeButton: true,
};

type IContent = string | number;

const Toast = {
  info(content: IContent, closeButton?: boolean, onClose?: () => any) {
    toast.info(<span className="toast-text">{content}</span>, {
      ...commonConfig,
      icon: '',
      className: 'toast-info',
      closeButton,
      onClose,
    });
  },
  success(content: IContent, closeButton?: boolean, onClose?: () => any) {
    toast.success(<span className="toast-text">{content}</span>, {
      ...commonConfig,
      icon: <img className="toast-icon" src={successIcon} alt="success" />,
      className: 'toast-success',
      closeButton,
      onClose,
    });
  },
  warning(content: IContent, closeButton?: boolean, onClose?: () => any) {
    toast.warn(<span className="toast-text">{content}</span>, {
      ...commonConfig,
      icon: <img className="toast-icon" src={warnIcon} alt="warn" />,
      className: 'toast-warn',
      closeButton,
      onClose,
    });
  },
  error(content: IContent, closeButton?: boolean, onClose?: () => any) {
    toast.error(<span className="toast-text">{content}</span>, {
      ...commonConfig,
      icon: <img className="toast-icon" src={errorIcon} alt="error" />,
      className: 'toast-error',
      closeButton,
      onClose,
    });
  },
  tip(content: IContent, closeButton?: boolean, config?: any) {
    toast.warn(<span className="toast-text">{content}</span>, {
      ...commonConfig,
      icon: <img className="toast-icon" src={warnIcon} alt="warn" />,
      className: 'toast-warn',
      closeButton,
      ...config
    });
  },
};

const ToastWrapper = () => (
  <ToastContainer
    className="toast-container"
    bodyClassName="toast-body"
    closeButton={(props: CloseButtonProps) => <span className="toast-close" />} // 修closeToast大写问题，有需要再添加对应属性
  />
);

export {
  ToastWrapper,
  Toast,
};
